
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../../..";
import { IPaymentGatewaysReducer } from "../../../../../reducers/paymentGatewaysReducer";
import { IAuthReducerState } from "../../../../../reducers/authReducer";
import { setPaymentGatewaysField, fetchPaymentGateways } from "../../../../../actions/paymentGatewaysActions";
import {  CreateNMIGatewayRequest, CreateNMIGatewayResponse, ReplaceGatewayToNMIRequest } from "../../../../../utils/grpc/generated/Billsby.Protos/billing/private/paymentgateway/payment_gateway_pb";
import { PaymentGatewayServiceClient } from "../../../../../utils/grpc/generated/Billsby.Protos/billing/private/paymentgateway/Payment_gatewayServiceClientPb";
import { grpcUnaryCall } from "../../../../../utils/grpc/grpcUtils";
import { ConfigConstants } from "../../../../../utils/config";
import PaymentGatewayContainer from "../payment-gateways-shared-components/PaymentGatewayContainer";
import NMIPaymentGatewayForm from "./NMIPaymentGatewayForm";

interface Props {
  onError: () => void;
}

const NMIPaymentGateway: React.FC<Props> = ({ onError }) => {
  const { selectedPaymentGateway, isCreatingGateway, replacedPaymentGateway } = useSelector<AppState, IPaymentGatewaysReducer>(state => state.paymentGatewaysReducer);
  const { currentCompanyDomain } = useSelector<AppState, IAuthReducerState>(state => state.auth);
  const dispatch = useDispatch<Function>()

  const [helpTitle, setHelpTitle] = useState("PAYMENT_GATEWAYS_ADDED_NMI_HELP");
  const [helpContent, setHelpContent] = useState(["PAYMENT_GATEWAYS_ADDED_NMI_HELP_CONTENT_1", "PAYMENT_GATEWAYS_ADDED_NMI_HELP_CONTENT_2"]);

  if (!selectedPaymentGateway) {
    return null;
  }

  const addNewPaymentGateway = async (displayName: string, username: string, password: string) => {
    const createNMIGatewayRequest = new CreateNMIGatewayRequest();
    createNMIGatewayRequest.setCompanyDomain(currentCompanyDomain);
    createNMIGatewayRequest.setDisplayName(displayName);
    createNMIGatewayRequest.setLogin(username);
    createNMIGatewayRequest.setPassword(password);
    const paymentGatewayServiceClient = new PaymentGatewayServiceClient(ConfigConstants.grpcBaseUrl);
    
    let request: Promise<any>
    if(replacedPaymentGateway) {
      const replaceGatewayToNMIRequest = new ReplaceGatewayToNMIRequest()
      replaceGatewayToNMIRequest.setCreateNmiRequest(createNMIGatewayRequest);
      replaceGatewayToNMIRequest.setPaymentGatewayToReplaceId(replacedPaymentGateway.paymentGatewayId as number);
      request = grpcUnaryCall(replaceGatewayToNMIRequest, paymentGatewayServiceClient, paymentGatewayServiceClient.replaceGatewayToNMI)
    }
    else {
      request = grpcUnaryCall(createNMIGatewayRequest, paymentGatewayServiceClient, paymentGatewayServiceClient.createNMIGateway)
    }

    try {
      const data = await request as CreateNMIGatewayResponse;
      dispatch(setPaymentGatewaysField("createdPaymentGatewayId", data.getPaymentGatewayId()));
      dispatch(setPaymentGatewaysField("selectedPaymentGateway", undefined));
      dispatch(setPaymentGatewaysField("replacedPaymentGateway", undefined));
      await dispatch(fetchPaymentGateways(currentCompanyDomain));
    } catch {
      onError();
    }
  }

  return (
    <PaymentGatewayContainer
      helpTitle={helpTitle}
      helpContent={helpContent}
      description="PAYMENT_GATEWAYS_NMI_DESCRIPTION"
      isOneGatewayPending={false}
      currentGatewayState={{ isCollapsed: false }}
      websiteLink="https://www.nmi.com/"
      type="create"
      paymentGateway={selectedPaymentGateway}
    >
      <NMIPaymentGatewayForm
        onSave={(displayName: string, apiLogin: string, password: string) => addNewPaymentGateway(displayName, apiLogin, password)}
        onCancel={() => {
          dispatch(setPaymentGatewaysField("selectedPaymentGateway", undefined));
          dispatch(setPaymentGatewaysField("replacedPaymentGateway", undefined));
        }}
        setHelpTitle={(text: string) => setHelpTitle(text)}
        setHelpContent={(text: Array<string>) => setHelpContent(text)}
        initDisplayName=""
        initUsername=""
        isSaveEnabled={!isCreatingGateway}
        isEdit={false}
      />
    </PaymentGatewayContainer>
  )
}

export default NMIPaymentGateway